<template>
<div class="category_input">
  <strong>{{category}}</strong>
  <v-chip-group multiple column :value="value" @change="listChange">
    <v-chip v-for="s in services" :key="s.service_id"
      small
      :disabled="claimed &&  !offered_ids.includes(s.service_id)"
      :color="colorFor(s.service_id)"
      :value="s.service_id"
      :style="styleFor(s.service_id)"
    >
      {{ s.service }}
    </v-chip>
  </v-chip-group>
</div>
</template>

<script>
export default {  
  props: {
    category: String,
    services: Array,
    value: Array,
    offered_ids: Array,
    claimed: Boolean,
  },

  data() {
    return { 
      items: []
    }
  },

  methods: {
    listChange(newVal) {
        this.$emit('input', newVal)
    },
    
    colorFor(id) {
      if (this.claimed) {
        // pro doesnt offer this service
        if (!this.offered_ids.includes(id)) return 'grey lighten-3'
  
        // pro offers this service AND NOT blacklisted
        if (!this.value.includes(id)) return 'primary'
  
        // blacklisted
        return 'grey darken-'
      } else {
        return this.value.includes(id) ? 'primary' : 'grey lighten-3'
      }
    },

    styleFor(id) {
      if (this.claimed) {
        // pro doesnt offer this service
        if (!this.offered_ids.includes(id)) return 'border: 1px solid #C0C0C0 !important;'

        // pro offers this service AND NOT blacklisted
        if (!this.value.includes(id)) return ''

        // blacklisted
        return 'border: 1px solid black !important;'
      } else {
        return !this.value.includes(id) ? 'border: 1px solid #C0C0C0 !important;' : ''
      }
    },
  },
}
</script>